import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "p-fluid" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "Chọn thời gian tìm kiếm: ", -1)
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Không có lượt đặt chỗ nào ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Panel = _resolveComponent("Panel")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "Danh sách thông tin tái khám của bệnh nhân" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Calendar, {
                  id: "date1",
                  modelValue: $setup.date1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.date1 = $event)),
                  selectionMode: "range",
                  dateFormat: "dd/mm/yy",
                  showButtonBar: true,
                  showIcon: true,
                  manualInput: false,
                  monthNavigator: true,
                  yearNavigator: true,
                  yearRange: "2000:2100",
                  onDateSelect: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectCalendar())),
                  onClearClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearCalendar()))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Danh sách tái khám" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_DataTable, {
            value: $setup.taiKham,
            paginator: true,
            stripedRows: "",
            rows: 20,
            rowsPerPageOptions: [20,50,100],
            rowHover: true,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['tenbenhnhan','cccd'],
            currentPageReportTemplate: "Có tất cả {totalRecords} lượt tái khám"
          }, {
            empty: _withCtx(() => [
              _hoisted_7
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "tenbenhnhan",
                header: "Họ và tên",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "cccd",
                header: "CCCD"
              }),
              _createVNode(_component_Column, {
                field: "mayte",
                header: "Mã y tế",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "namsinh",
                header: "Năm sinh",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "ngaysinh",
                header: "Ngày tháng năm sinh",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaysinh)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "diachithuongtru",
                header: "Địa chỉ",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "sodienthoai",
                header: "Số điện thoại",
                sortable: ""
              }),
              _createVNode(_component_Column, {
                field: "ngaytaikham",
                header: "Ngày tái khám",
                sortable: ""
              }, {
                body: _withCtx(({data}) => [
                  _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngaytaikham)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    })
  ], 64))
}